import { namedObjectSchema, requiredNamedObjectSchema } from './named-object.js';
import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
export const activeIngredientMaxLength = 60;
export const activeIngredientSchema = z.object({
    ingredient: namedObjectSchema.nullish().transform(nullishToUndefined).optional(),
    doseAmount: z.number().nullish().transform(nullishToUndefined).optional(),
    doseUnit: requiredNamedObjectSchema.nullish().transform(nullishToUndefined).optional(),
});
export function toActiveIngredient(activeIngredient) {
    const result = activeIngredientSchema.safeParse(activeIngredient);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid ActiveIngredient object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=active-ingredient.js.map